import { apiCall } from "./firebase";

export interface Todo {
  id: string;
  title: string;
  todoName?: string;
  priority: "high" | "medium" | "low";
  deadline?: Date;
  completed: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateTodoData {
  title: string;
  todoName?: string;
  priority?: "high" | "medium" | "low";
  deadline?: string;
}

export interface UpdateTodoData {
  title?: string;
  todoName?: string;
  priority?: "high" | "medium" | "low";
  deadline?: string;
  completed?: boolean;
}

export interface TodoStats {
  total: number;
  completed: number;
  pending: number;
  overdue: number;
}

export class TodoService {
  async getTodos(): Promise<Todo[]> {
    try {
      const response = await apiCall("/getTodos");
      return response.todos || [];
    } catch (error) {
      console.error("Error fetching todos:", error);
      throw error;
    }
  }

  async createTodo(data: CreateTodoData): Promise<Todo> {
    try {
      const response = await apiCall("/createTodo", {
        method: "POST",
        body: JSON.stringify(data),
      });
      return response.todo;
    } catch (error) {
      console.error("Error creating todo:", error);
      throw error;
    }
  }

  async updateTodo(todoId: string, data: UpdateTodoData): Promise<Todo> {
    try {
      const response = await apiCall("/updateTodo", {
        method: "POST",
        body: JSON.stringify({ todoId, ...data }),
      });
      return response.todo;
    } catch (error) {
      console.error("Error updating todo:", error);
      throw error;
    }
  }

  async markTodoCompleted(todoId: string, completed: boolean): Promise<Todo> {
    return this.updateTodo(todoId, { completed });
  }

  async deleteTodo(todoId: string): Promise<void> {
    try {
      await apiCall("/deleteTodo", {
        method: "POST",
        body: JSON.stringify({ todoId }),
      });
    } catch (error) {
      console.error("Error deleting todo:", error);
      throw error;
    }
  }

  async getTodoStats(): Promise<TodoStats> {
    try {
      const response = await apiCall("/getTodoStats");
      return response.stats;
    } catch (error) {
      console.error("Error fetching todo stats:", error);
      throw error;
    }
  }
}

// Create singleton instance
export const todoService = new TodoService();
